import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let items = state.get('items') || Map(),
        id = parseInt(action.id, 10);
    items = items.set(
        id,
        (items.get(id) || Map())
            .set('state', 'IN_PROGRESS')
    );
    return state.set('items', items);
}

export function error(state, action) {
    let items = state.get('items') || Map(),
        id = parseInt(action.id, 10);

    items = items.set(
        id,
        (items.get(id) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );

    return state.set('items', items);
}

export function finish(state, { id }) {
    let items = state.get('items') || Map();
    items = items.set(
        +id,
        (items.get(+id) || Map())
            .set('_full', true)
            .set('state', 'FINISHED')
    );
    return state.set('items', items);
}
